'use strict';

function generateStorageAccessModeOption ( config ) {
    var gettext = require('mag-gettext').gettext,

        envVarName        = 'mount_media_ro',
        optionEnvironment = {};

    // default value
    optionEnvironment[envVarName] = 'false';

    return {
        id: 'storageAccessMode',
        icon: 'theme-icon-categories-rotate',
        name: gettext('Storage access mode'),
        description: gettext(
            'Setting the access option for the data storage connected to the USB port of the device: read-only and full access.'
        ),
        requireDeviceReboot: true,
        environment: optionEnvironment,
        prepareForRender: function ( environment, render ) {
            var preparedData = [
                {name: gettext('Read only'), value: 'true', selected: environment[envVarName] === 'true'},
                {name: gettext('Full access'), value: 'false', selected: environment[envVarName] === 'false'}
            ];

            render(preparedData);
        },
        prepareForSave: function ( value, save ) {
            this.environment[envVarName] = value;

            save();
        },
        render: config.api.renders.popupSelect,
        getter: config.api.getters.environment,
        saver: config.api.savers.environment,
        parent: 'system'
    };
}


// public interface
module.exports = {
    onSettingsInit: function ( config, callback ) {
        require('mag-gettext').load({
            name: core.environment.language,
            path: config.path + 'lang'
        }, function () {
            var data = {
                    id: 'systemMag',
                    name: 'system section',
                    description: 'system section general description',
                    options: []
                },
                model = core.device.model,
                gettext = require('mag-gettext').gettext;

            if ( model !== 'emulator' && model !== 'emulator_stb' ) {
                data.options.push(generateStorageAccessModeOption(config));
            }

            if ( config.api.actions.clearUserData ) {
                data.options.push({
                    id: 'clearUserData',
                    name: gettext('Clear user data'),
                    description: gettext(
                        'User data will be permanently deleted (logins, passwords, location, favorite channels, Internet bookmarks, etc.).'
                    ),
                    icon: 'theme-icon-clear',
                    confirmation: {
                        title: gettext('Clear data?'),
                        callback: function ( result ) {
                            if ( result ) {
                                config.api.actions.clearUserData();
                            }
                        }
                    },
                    requirePortalReboot: true,
                    render: config.api.renders.confirm,
                    parent: 'system'
                });
            }

            if ( model !== 'emulator' && model !== 'emulator_stb' ) {
                if ( config.api.actions.reload ) {
                    data.options.push({
                        id: 'restartPortal',
                        name: gettext('Restart portal'),
                        description: gettext(
                            'Exit the current portal, and a list of available portals will be displayed. ' +
                            'This is necessary if you change the language, for example.'
                        ),
                        icon: 'theme-icon-reload',
                        confirmation: {
                            title: gettext('Restart portal?'),
                            callback: function ( result ) {
                                if ( result ) {
                                    config.api.actions.reload();
                                }
                            }
                        },
                        render: config.api.renders.confirm,
                        parent: 'system'
                    });
                }
            }

            if ( config.api.actions.reboot ) {
                if ( model !== 'emulator' && model !== 'emulator_stb' ) {
                    data.options.push({
                        id: 'rebootDevice',
                        name: gettext('Reboot device'),
                        description: gettext(
                            'Click or press "ok" to reboot the device.'
                        ),
                        icon: 'theme-icon-reboot',
                        confirmation: {
                            title: gettext('Reboot device?'),
                            callback: function ( result ) {
                                if ( result ) {
                                    config.api.actions.reboot();
                                }
                            }
                        },
                        render: config.api.renders.confirm,
                        parent: 'system'
                    });
                } else {
                    data.options.push({
                        id: 'restartPortal',
                        name: gettext('Restart portal'),
                        description: gettext(
                            'Exit the current portal, and a list of available portals will be displayed. ' +
                            'This is necessary if you change the language, for example.'
                        ),
                        icon: 'theme-icon-reload',
                        confirmation: {
                            title: gettext('Restart portal?'),
                            callback: function ( result ) {
                                if ( result ) {
                                    config.api.actions.reboot();
                                }
                            }
                        },
                        render: config.api.renders.confirm,
                        parent: 'system'
                    });
                }
            }

            if ( config.api.actions.resetUserFs ) {
                data.options.push(                   {
                    id: 'resetDeviceUserSettings',
                    name: gettext('Reset user settings'),
                    description: gettext('Reset to factory settings'),
                    icon: 'theme-icon-reset',
                    confirmation: {
                        title: gettext('Reset settings? All data will be erased.'),
                        callback: function ( result ) {
                            if ( result ) {
                                config.api.actions.resetUserFs();
                            }
                        }
                    },
                    render: config.api.renders.confirm,
                    parent: 'system'
                });
            }

            callback(null, data);
        });
    }
};
